export default __webpack_public_path__ + "static/media/hair-cold-summer.e8cdca31.png";